import Cookies from "js-cookie";
import API from "./API";
import TenantAPI from "./TenantAPI";
import { UpdateSharedPayload } from "../api-hooks/sharedRecords/useUpdateSharedRecord";

export default class SharedRecordAPI {
  static async getUserSharedRecord(recordID: string) {
    return API._bearerRequest(
      "get",
      `/share/records/${recordID}/user`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getSharedRecord(sharedRecordID: string, password?: string) {
    return API._bearerRequest(
      "put",
      `/share/records/getSharedRecord/${sharedRecordID}`,
      password ? { password } : null,
      Cookies.get("authenticationToken")
    );
  }

  static async createSharedRecord(payload: any) {
    return API._bearerRequest(
      "post",
      `/share/records/`,
      { payload },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteSharedRecord(recordID: string) {
    return API._bearerRequest(
      "delete",
      `/share/records/${recordID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getTenantsWithApp(recordID: string) {
    return API._bearerRequest(
      "get",
      `/share/records/${recordID}/cloudsWithApp/`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async addSharedRecord(recordID: string, cloudID: string) {
    return API._bearerRequest(
      "post",
      `/share/records/${recordID}/addToCloud/${cloudID}`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async updateRecordWithShared(recordID: string, cloudID: string) {
    return API._bearerRequest(
      "put",
      `/share/records/${recordID}/updateRecordWithSharedRecord/${cloudID}`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async mergeRecordWithShared(
    recordID: string,
    cloudID: string,
    payload: any
  ) {
    return API._bearerRequest(
      "put",
      `/share/records/${recordID}/mergeRecordWithSharedRecord/${cloudID}`,
      { payload },
      Cookies.get("authenticationToken")
    );
  }

  static async updateSharedRecordExpiration(
    recordID: string,
    newExpiration: string | null,
    pageID: string,
    viewID: string
  ) {
    let payload;

    if (!newExpiration) {
      payload = { expire: true, viewID, pageID };
    } else {
      payload = { expiration: newExpiration, viewID, pageID };
    }

    return API._bearerRequest(
      "put",
      `/share/records/${recordID}/unshareSharedRecord`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateSharedRecord(
    recordID: string,
    payload: UpdateSharedPayload
  ) {
    return API._bearerRequest(
      "put",
      `/share/records/${recordID}/updateSharedRecord`,
      { payload },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async leaveSync(recordID: string, sharedRecordID: string) {
    return API._bearerRequest(
      "put",
      `/share/records/${recordID}/leaveSync/${sharedRecordID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  /**
   * Shared Record Page endpoints
   */

  static async GetSharedRecordPageInTenant(recordID: string, viewID: string) {
    return API._bearerRequest(
      "get",
      `/share/records/${recordID}/view/${viewID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async GetSharedRecordPage(
    sharedRecordPageID: string,
    tenantID: string,
    password?: string
  ) {
    return API._bearerRequest(
      "put",
      `/share/records/${sharedRecordPageID}/getSharedRecordPage/${tenantID}`,
      { password },
      Cookies.get(`authenticationToken`)
    );
  }

  static CreateSharedRecordPage(body: any) {
    return API._bearerRequest(
      "post",
      `/share/records/sharedRecordPage`,
      body,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static UpdateSharedRecordPage(recordID: string, viewID: string, body: any) {
    return API._bearerRequest(
      "put",
      `/share/records/${recordID}/view/${viewID}`,
      body,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static UnshareRecordPage(recordID: string, viewID: string) {
    return API._bearerRequest(
      "delete",
      `/share/records/${recordID}/view/${viewID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
